// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"17b24eb0","436":"17b24eb0"}[chunkId] + ".chunk.css";
};